import { render, staticRenderFns } from "./DialogAddInfoDashboard.vue?vue&type=template&id=78f89568&scoped=true"
import script from "./DialogAddInfoDashboard.vue?vue&type=script&lang=js"
export * from "./DialogAddInfoDashboard.vue?vue&type=script&lang=js"
import style0 from "./DialogAddInfoDashboard.vue?vue&type=style&index=0&id=78f89568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f89568",
  null
  
)

export default component.exports